"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var styles = _interopRequireWildcard(require("./View.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The flex component provides a declarative method for creating Flex-based
 * layouts by configuring prop values that map to commonly-used Flex properties.
 */
const View = /*#__PURE__*/React.forwardRef(({
  alignContent,
  alignItems,
  alignSelf,
  as: Component = 'div',
  children,
  flex,
  flexDirection,
  flexWrap,
  gap,
  inline,
  justifyContent,
  margin,
  padding,
  overflow,
  flexGrow,
  css,
  cssProps,
  ...otherProps
}, ref) => {
  // merging styles
  const mergedCSS = args => ({ ...styles.view(args),
    ...(css ? css(args) : {})
  });

  return (0, _pragma.createFelaElement)(Component, _extends({
    css: mergedCSS,
    cssProps: {
      alignContent,
      alignItems,
      alignSelf,
      flex,
      flexDirection,
      flexWrap,
      inline,
      justifyContent,
      margin,
      padding,
      overflow,
      flexGrow,
      ...cssProps
    },
    ref: ref
  }, otherProps), gap ? (0, _pragma.createFelaElement)("div", {
    css: styles.gap,
    cssProps: {
      alignContent,
      alignItems,
      flexDirection,
      flexWrap,
      gap,
      inline,
      justifyContent
    }
  }, children) : children);
});
View.displayName = 'View';
var _default = View;
exports.default = _default;
//# sourceMappingURL=View.js.map